<template>
  <div id="welcome">
    <el-row :gutter="12">
      <template v-if="this.pageListData.list && this.pageListData.list.length>0">
        <el-col :span="8" v-for="(item,index) in  this.pageListData.list" @click.native='getInfo(item.id)'>
          <el-card shadow="hover" class="box-card">
            <div slot="header" class="clearfix">
              <el-badge v-if="item.isNew==1" value="new" class="item">{{item.tag}}</el-badge>
              <el-badge v-else class="item">{{item.tag}}</el-badge>
              <span style="float: right" type="text">{{resolvingDate(item.createTime)}}</span>
            </div>
            <div class="text item">
              <h3 class="jhh-notices">{{item.title}}</h3>
              <p class="gome-shop">
                {{item.memo}}
              </p>

            </div>
          </el-card>
        </el-col>
      </template>
    </el-row>
  </div>
</template>
<script>
  import {getNoticeByDate, getNoticeMd, getWebSocket} from '../api/api'

  export default {
    name: 'welcome',
    data() {
      return {
        theData: '',
        pageListData: {},
        currentPage: 1,
        currentRow: 10,
        noticeInfo: '',
      }
    },
    mounted() {
      // 取值时：把获取到的Json字符串转换回对象
      var userJsonStr = localStorage.getItem('userInfo');
      var userEntity = JSON.parse(userJsonStr);
      // console.log(userEntity.loginName); // => tom

      let authListDate = [];
      authListDate = JSON.parse(localStorage.getItem('authList'));
      this.getNoticeAll();
      // WebSocket
      if ('WebSocket' in window) {
        let url = getWebSocket + userEntity.userId;
        this.websocket = new WebSocket(url);
        this.initWebSocket()
      } else {
        alert('当前浏览器 Not support websocket')
      }

    },
    beforeDestroy() {
      this.onbeforeunload()
    },
    methods: {
      //获取公告信息
      getNoticeAll() {
        // let params = {
        //   pageSize: this.currentRow,
        //   startRow:this.currentPage,
        // };
        // selectNoticeAll(params).then(response => {
        //   if (response.data.status == 100) {
        //     this.pageListData = response.data.results;
        //   }
        // }).catch((error) => {
        //   this.$Message.error(error.message);
        // })
        let params = {};
        getNoticeByDate(params).then(response => {
          if (response.data.status == 100) {
            this.pageListData = response.data.results;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        });
      },
      //详情
      getInfo(id) {
        if (id) {
          let params = {
            id: id
          };
          getNoticeMd(params).then(response => {
            if (response.data.status == 100) {
              this.noticeInfo = response.data.results;
              this.showMessage();
            }
          }).catch((error) => {
            this.$Message.error(error.message);
          })
        }
      },
      showMessage() {
        this.$msgbox({
          title: '公告内容',
          message: this.noticeInfo.content,
          dangerouslyUseHTMLString: true,
          showConfirmButton: false
        }).catch((error) => {
        })
      },
      /*时间格式化*/
      resolvingDate: function (date) {
        if (!date) {
          return "";
        }
        let d = new Date(date);
        let month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
        let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();

        let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      },
      initWebSocket() {
        // 连接错误
        this.websocket.onerror = this.setErrorMessage;

        // 连接成功
        this.websocket.onopen = this.setOnopenMessage;

        // 收到消息的回调
        this.websocket.onmessage = this.setOnmessageMessage;

        // 连接关闭的回调
        this.websocket.onclose = this.setOncloseMessage;

        // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        window.onbeforeunload = this.onbeforeunload
      },
      setErrorMessage() {
      },
      setOnopenMessage() {
      },
      setOnmessageMessage(event) {
        // 根据服务器推送的消息做自己的业务处理
        console.log('服务端返回：' + event.data);
        this.$notify({
          title: '系统公告',
          message: event.data + "<br><a href='/' target='_self'>详情</a>",
          dangerouslyUseHTMLString: true,
          type: 'info',
          duration: 0

        });
      },
      setOncloseMessage() {
      },
      onbeforeunload() {
        this.closeWebSocket()
      },
      closeWebSocket() {
        this.websocket.close()
      }
    },
  }
</script>
<style lang="scss" scoped>
  #welcome {
    .jhh-notices {
      color: #e50038;
    }
  }
</style>



// WEBPACK FOOTER //
// Welcome.vue?431c7257